import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { Observable } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class DialogsService {

    private snackBar = inject(MatSnackBar);

    constructor
        (
            private _fuseConfirmationService: FuseConfirmationService,
            private matDialog: MatDialog

        ) { }


    snackBarSuccess(message: string, title: string = 'Éxito'): void {

        this.snackBar.open(message, 'Cerrar', {
            horizontalPosition: 'right', // 'start', 'center', 'end', 'left', 'right'
            verticalPosition: 'bottom',  // 'top', 'bottom'
            duration: 3000,
            panelClass: 'success-snackbar'
        });
    }

    snackBarError(message: string, title: string = 'Error'): void {

        this.snackBar.open(message, 'Cerrar', {
            horizontalPosition: 'right', // 'start', 'center', 'end', 'left', 'right'
            verticalPosition: 'bottom',  // 'top', 'bottom'
            duration: 3000,
            panelClass: 'error-snackbar'
        });
    }

    success(title: any, msg: any) {
        return this._fuseConfirmationService.open({
            "title": title,
            "message": msg,
            "icon": {
                "show": true,
                "name": "heroicons_outline:check",
                "color": "success"
            },
            "actions": {
                "confirm": {
                    "show": true,
                    "label": "Aceptar",
                    "color": "primary"
                },
                "cancel": {
                    "show": false,
                    "label": "Cancelar"
                }
            },
            "dismissible": true
        });
    }

    error(title: any, msg: any) {
        return this._fuseConfirmationService.open({
            "title": title,
            "message": msg,
            "icon": {
                "show": true,
                "name": "heroicons_outline:exclamation-triangle",
                "color": "error"
            },
            "actions": {
                "confirm": {
                    "show": true,
                    "label": "Aceptar",
                    "color": "warn"
                },
                "cancel": {
                    "show": false,
                    "label": "Cancelar"
                }
            },
            "dismissible": true
        });
    }

    confirm(title: any, msg: any, confirmLabel: string = 'Aceptar'): Observable<boolean> {
        const dialogRef = this._fuseConfirmationService.open({
            "title": title,
            "message": msg,
            "icon": {
                "show": true,
                "name": "heroicons_outline:question-mark-circle",
                "color": "accent"
            },
            "actions": {
                "confirm": {
                    "show": true,
                    "label": confirmLabel,
                    "color": "accent"
                },
                "cancel": {
                    "show": true,
                    "label": "Cancelar"
                }
            },
            "dismissible": true
        });

        return dialogRef.afterClosed();
    }

    info(title: any, msg: any) {
        return this._fuseConfirmationService.open({
            "title": title,
            "message": msg,
            "icon": {
                "show": true,
                "name": "heroicons_outline:information-circle",
                "color": "info"
            },
            "actions": {
                "confirm": {
                    "show": true,
                    "label": "Aceptar",
                    "color": "accent"
                },
                "cancel": {
                    "show": false,
                    "label": "Cancelar"
                }
            },
            "dismissible": true
        });
    }

}
